<!--
    @file:Echarts组件,
    @props {Object} option 用于echarts图表的阐述
    @props {string} idChart 新建Echarts的DOM结构的id
-->
<template>
    <div v-bind:id="idChart" class="chart">
    </div>
</template>

<script>
import echarts from 'echarts';
export default {
    name: 'chart',
    mounted () {
        var self = this;
        this.chartObject = echarts.init(this.$el);
        window.onresize = function temp () {
            self.chartObject.resize();
        };
        this.chartObject.setOption(this.option);
    },
    data () {
        return {
            chartObject: null
        };
    },
    props: ['option', 'idChart'],
    watch: {
        option: {
            handler: function (val, newVal) {
                console.log('change option', val);
                this.chartObject.setOption(val);
                this.chartObject.resize();
            },
            deep: true
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart{
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// chart.vue?197cd5c9